import { nativeInputStyle } from "./native-settings-style.js";
// Native popups do not reliably inherit the select's surface. Pair each option's
// opaque surface and foreground using app-theme tokens, not OS theme detection.
// System-color fallbacks keep older hosts without these tokens readable.
const optionStyle = {
    backgroundColor: 'var(--dsw-alias-bg-layer-1, Canvas)',
    color: 'var(--dsw-alias-label-primary, CanvasText)',
};
const disabledOptionStyle = {
    ...optionStyle,
    color: 'var(--dsw-alias-label-secondary, GrayText)',
};
const selectStyle = {
    ...nativeInputStyle,
    ...optionStyle,
    width: '100%', minWidth: 0, boxSizing: 'border-box',
};
const disabledSelectStyle = {
    ...selectStyle,
    color: 'var(--dsw-alias-label-secondary, GrayText)',
};
export function nativeSelectStyle(disabled = false) {
    return disabled ? disabledSelectStyle : selectStyle;
}
export function nativeOptionStyle(disabled = false) {
    return disabled ? disabledOptionStyle : optionStyle;
}
//# sourceMappingURL=native-select-style.js.map